import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58599a2b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "protocal-rule-box"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  ref: "container",
  class: "protocal-content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "protocal-content-title"
};
const _hoisted_7 = {
  class: "title_text"
};
const _hoisted_8 = {
  class: "public_time"
};
import { env } from "md-base-tools/env";
import domain from "@/service/domain";
import { getRulePublicityList } from "@/api/index";
import { reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  setup(__props) {
    const state = reactive({
      public_status: 0,
      // 0: 公示中, 1: 已公示
      list: [],
      tabList: [{
        title: '公示中',
        id: 0
      }, {
        title: '已公示',
        id: 1
      }],
      offsetTabTop() {
        let top = 88 / 75 + 'rem';
        if (env.isModianIos() || env.isModianAndroid()) {
          top = 176 / 75 + 'rem';
        }
        return top || 0;
      }
    });
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
      document.title = '立规公示';
      state.son_id = route.params.son_id;
      state.fater_id = route.params.fater_id;
      getList();
    });
    const getList = () => {
      getRulePublicityList({
        public_status: state.public_status
      }).then(res => {
        state.list = res.data;
      });
    };
    const handleTabChange = id => {
      if (state.public_status === id) return;
      state.public_status = id;
      getList();
    };
    function handleView(id) {
      if (!id) return;
      const url = `${domain.wap}/protocal/rule/detail/${id}`;
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: url,
        webFun: () => {
          router.push({
            path: `/protocal/rule/detail/${id}`,
            query: {}
          });
        }
      });
    }
    const formatPublicTime = value => {
      if (!value) return "";
      if (typeof value !== "string") return value;
      const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
      if (!isoPattern.test(value)) return value;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    return (_ctx, _cache) => {
      const _component_van_sticky = _resolveComponent("van-sticky");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, {
        "offset-top": _unref(state).offsetTabTop(),
        container: "protocal-rule-box"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tabList, (tabItem, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['sub_category', {
              'active': _unref(state).public_status === tabItem.id
            }]),
            onClick: _withModifiers($event => handleTabChange(tabItem.id), ["stop"])
          }, _toDisplayString(tabItem.title), 11, _hoisted_3);
        }), 128))])]),
        _: 1
      }, 8, ["offset-top"]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "rule_column",
          onClick: _withModifiers($event => handleView(item.id), ["prevent"])
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("strong", _hoisted_7, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_8, "公示时间：" + _toDisplayString(formatPublicTime(item.public_time)), 1)], 8, _hoisted_5);
      }), 128))], 512)]);
    };
  }
};